import React from "react";
import ico from '../assets/favicon.png';
import { Link, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";


import { BsDiscord } from 'react-icons/bs';
import Swal from "sweetalert2";

export default function Header(props) {

    const corPrincipal = '#dc494c';

    const scrollTo = (where) => {
        scroller.scrollTo(where, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
    }

    const navigate = useNavigate();

    const mensagem = (a = null) => {
        if (a !== null) {
            a.preventDefault();
        }
        Swal.fire({ title: 'Quase lá !', html: '<p>Relaxa, você não fez nada de errado.</p><br/><p>Acontece que o site ainda não está pronto. Estamos desenvolvendo ele dia após dia. Oque você vê aqui é apenas uma demostração visual de como a página principal do site ficará. Logo botões e as demais ações estão desabilitadas.</p>', icon: 'info' }).then(() => {
            Swal.fire({ title: 'Fique por dentro :)', html: "<p>Em nossas redes sociais você saberá certinho como está sendo todo o processo de desenvolvimento do seu Bar preferido (Taldo's Bar) com videos e etc.</p><br /><p>Eai, vem ficar pertinho da gente !!! </p><a style='color:blue;text-decoration:underline' href='" + window.location.origin + "'>Clique aqui</a>", icon: 'info' })
        })
    }


    if (props.padrao != 'link') {
        return (
            <header className='header-principal'>
                <div className='part1-header-principal animate__animated animate__lightSpeedInLeft'>
                    <div style={{ backgroundImage: `url(${ico})` }} className='icon-header' ></div>
                    <a to="scroll" onClick={() => scrollTo('players')} >Players</a>
                    <a to="scroll" onClick={() => scrollTo('players')} >Mestres</a>
                    <h1>|</h1>
                    <a target="_blank" href="https://apoia.se/taldobars">Apoia-se</a>
                    <a onClick={(a) => mensagem(a)} href="">Ajuda</a>
                </div>
                <div className='part2-header-principal animate__animated animate__backInRight'>
                    <a target="_blank" className='discord-login' href="https://discord.gg/acMgWMDeBC"><BsDiscord size={30} /></a>
                    <Link style={{ borderColor: corPrincipal, borderWidth: 1 }} className='button' onClick={(a) => mensagem(a)} to="">Login</Link>
                </div>
            </header>

        )
    } else {
        return (
            <header className='header-principal'>
                <div className='part1-header-principal animate__animated animate__lightSpeedInLeft'>
                    <div style={{ backgroundImage: `url(${ico})` }} className='icon-header' ></div>
                    <Link to="/site/?i=players">Players</Link>
                    <Link to="/site/?i=mestres">Mestres</Link>
                    <h1>|</h1>
                    <a target="_blank" href="https://apoia.se/taldobars">Apoia-se</a>
                    <a onClick={(a) => mensagem(a)} href="">Ajuda</a>
                </div>
                <div className='part2-header-principal animate__animated animate__backInRight'>
                    <a target="_blank" className='discord-login' href="https://discord.gg/acMgWMDeBC"><BsDiscord size={30} /></a>
                    <a onClick={() => { navigate(-1) }} style={{ borderColor: corPrincipal, borderWidth: 1, cursor: 'pointer' }} className='button'>Voltar</a>
                </div>
            </header>
        )
    }

}